export default __webpack_public_path__ + "static/media/india.b1e9cfc7.png";